landerPage = {
	// an object that is only called on the cholesterol pages
	init: function initialize(){
		this.cE();
		this.eL();
	},
	cE: function cacheElements(){

	},
	
	eL: function eventListeners(){
		/**
		 ##########################################################################################
		 
		 ANIMATE ICONS WHEN VISIBLE
		 
		 ##########################################################################################
		 **/
		
		var controller = new ScrollMagic.Controller();
		
		TweenLite.set([bad45_txt, bad45_numbers], {visibility:"visible"});
		
		var tlbad45 = new TimelineMax({});
		tlbad45
			.fromTo(circleRed_bad45, 2.3, {drawSVG:"0% 0%", ease:Sine.easeOut},{drawSVG:"0% 45%", ease:Power1.easeOut}, "bad45")
			.from(bad45_txt_1, .7, {opacity:0, ease:Power0.easeNone}, "bad45+=.2")
			.from(bad45_txt_2, .7, {opacity:0, ease:Power0.easeNone}, "bad45+=.4")
		;

		var tl45numbers = new TimelineMax({});
		tl45numbers
			.from(bad45_percent, .5, {opacity:0, ease:Power0.easeNone}, "45numbers")
			.from(bad45_percent, 1, {x:"-=20", ease:Power4.easeOut}, "45numbers")
			.from(ones_1, .2, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers")
			.from(ones_2, .2, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=.3")
			.from(ones_3, .1, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=.6")
			.from(ones_4, .1, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=.7")
			.from(ones_5, .1, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=.8")
			.from(ones_0, .1, {opacity:0, yoyo:true, repeat:1, repeatDelay:.3, ease:Power0.easeNone}, "45numbers+=.9")
			
			.from(tens_1, .1, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=.8")
			.from(tens_2, .1, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=1")
			.from(tens_3, .1, {opacity:0, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=1.1")
			.from(tens_4, .1, {opacity:0, ease:Power0.easeNone}, "45numbers+=1.2")
			
			.to(ones_1, .1, {opacity:1, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=1.3")
			.to(ones_2, .1, {opacity:1, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=1.4")
			.to(ones_3, .1, {opacity:1, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=1.5")
			.to(ones_4, .2, {opacity:1, yoyo:true, repeat:1, ease:Power0.easeNone}, "45numbers+=1.6")
			.to(ones_5, .6, {opacity:1, ease:Power0.easeNone}, "45numbers+=1.8")
		;
		tlbad45.timeScale(1.5);
		tl45numbers.timeScale(1.5);
		// shoulder pain
		var tlpain2 = new TimelineMax({yoyo:true, repeat:-1, repeatDelay:.7, yoyoEase:Expo.easeOut});
		tlpain2
			.from(ache_dot_shoulder, .5, {opacity:.5, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain2")
			.from(ache_circ1_shoulder, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain2+=.1")
			.from(ache_circ2_shoulder, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain2+=.2")
			.from(ache_circ3_shoulder, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain2+=.3")
			.from(ache_circ4_shoulder, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power3.easeInOut}, "pain2+=.4")
			.from(ache_circ5_shoulder, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power3.easeInOut}, "pain2+=.5")
			.from(ache_circ6_shoulder, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power4.easeInOut}, "pain2+=.6")
			.from(ache_circ7_shoulder, .5, {opacity:.5, scale:.8, transformOrigin:"center", ease:Power4.easeInOut}, "pain2+=.7")
			.from(ache_circ8_shoulder, .5, {opacity:.3, scale:.8, transformOrigin:"center", ease:Back.easeOut.config(1)}, "pain2+=.8")
			.from(ache_circ9_shoulder, .5, {opacity:.3, scale:.8, transformOrigin:"center", ease:Back.easeOut.config(3)}, "pain2+=.9")
		;
		// arm pain
		var tlpain3 = new TimelineMax({yoyo:true, repeat:-1, repeatDelay:1, yoyoEase:Expo.easeOut});
		tlpain3
			.from(ache_dot_arm, .5, {opacity:.5, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain3")
			.from(ache_circ1_arm, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain3+=.1")
			.from(ache_circ2_arm, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain3+=.2")
			.from(ache_circ3_arm, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power2.easeInOut}, "pain3+=.3")
			.from(ache_circ4_arm, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power3.easeInOut}, "pain3+=.4")
			.from(ache_circ5_arm, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power3.easeInOut}, "pain3+=.5")
			.from(ache_circ6_arm, .5, {opacity:.7, scale:.8, transformOrigin:"center", ease:Power4.easeInOut}, "pain3+=.6")
			.from(ache_circ7_arm, .5, {opacity:.5, scale:.8, transformOrigin:"center", ease:Power4.easeInOut}, "pain3+=.7")
			.from(ache_circ8_arm, .5, {opacity:.3, scale:.8, transformOrigin:"center", ease:Back.easeOut.config(1)}, "pain3+=.8")
			.from(ache_circ9_arm, .5, {opacity:.3, scale:.8, transformOrigin:"center", ease:Back.easeOut.config(3)}, "pain3+=.9")
		;
		// medications anim
		TweenLite.set([meds], {visibility:"visible"});
		
		var tlmeds = new TimelineMax({});
		tlmeds
			.from(rx_paper, 1.2, {x:"-=90", rotation:-15, ease:Power2.easeOut}, "meds")
			.from(bottomLeft1, 1, {x:"+=80", y:"-=60", rotation:45, ease:Power1.easeOut}, "meds+=.2")
			.from(bottomLeft2, .5, {x:"-=10", opacity:0, ease:Power1.easeOut}, "meds+=1")
			.from(oval_bottomRight, 1, {x:"-=60", y:"-=60", rotation:-65, transformOrigin:"center", ease:Power1.easeOut}, "meds+=.5")
			.from(oval_topLeft, 1, {x:"+=70", y:"+=10", rotation:-45, ease:Power1.easeOut}, "meds+=.2")
			.from(round_topLeft, .5, {x:"-=10", y:"-=10", opacity:0, ease:Power1.easeOut}, "meds+=.7")
		;
		
		// controls timing of all 3 anims
		var TL = new TimelineMax({});
		TL.add(tlbad45, 0) .add(tl45numbers, 0) .add(tlpain2, 2) .add(tlpain3, 1.5) .add(tlmeds, 2);
		
		var scene1 = new ScrollMagic.Scene({
			triggerElement: "#animate-icons"
		})
			.setTween(TL);
		
		controller.addScene([
			scene1
		]);
		
	}
	
}
